import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check, Loader2, ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, translating, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const current = languages.find(([c]) => c === lang) || languages[0];

  return (
    <div className="relative" ref={ref} data-no-translate data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 rounded-full text-burgundy/90 hover:bg-rose-soft/40 transition-colors ${compact ? 'px-3 py-2 w-full justify-between' : 'h-10 px-3'}`}
        aria-label="Change language"
        data-testid="language-switcher-btn"
      >
        <span className="flex items-center gap-1.5">
          {translating ? <Loader2 className="w-4 h-4 animate-spin" /> : <Globe className="w-4 h-4" />}
          <span className={compact ? 'text-[15px]' : 'text-[14px] hidden lg:inline'}>{current[1]}</span>
        </span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className={`absolute ${compact ? 'left-0 right-0' : 'right-0'} mt-2 z-[60] min-w-[170px] max-h-[60vh] overflow-auto rounded-2xl bg-cream border border-rose/40 shadow-xl p-1.5`} data-testid="language-menu">
          {languages.map(([code, label]) => (
            <button
              key={code}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3.5 py-2 rounded-xl text-[15px] transition-colors ${lang === code ? 'bg-rose-soft/60 text-mahogany' : 'text-burgundy/90 hover:bg-rose-soft/40'}`}
              data-testid={`language-option-${code}`}
            >
              {label}
              {lang === code && <Check className="w-4 h-4" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
